import { render, staticRenderFns } from "./lastFollowResult.vue?vue&type=template&id=19caa412&scoped=true&"
import script from "./lastFollowResult.vue?vue&type=script&lang=js&"
export * from "./lastFollowResult.vue?vue&type=script&lang=js&"
import style0 from "./lastFollowResult.vue?vue&type=style&index=0&id=19caa412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19caa412",
  null
  
)

export default component.exports